import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { navilinkUserSignIn } from "../SignInApi";
import Popup from "reactjs-popup";

import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useLocation } from "react-router-dom";
import NavilinkSignInCss from "./NavilinkSignIn.module.css";
import MainLogoImage from "../images/navilink/logo.png";
import IdIcon from "../images/navilink/ico_login_id_mo.png";
import PwIcon from "../images/navilink/ico_login_pw_mo.png";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const NavilinkSignIn = ({ history }) => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [idState, setIdState] = useState("");
  const [passwordState, setPasswordState] = useState("");
  const [idResetBtnState, setIdResetBtnState] = useState(false);
  const [passwordShowBtnState, setPasswordShowBtnState] = useState(false);
  const [loginButtonState, setLoginButtonState] = useState(false);
  const [popupState, setPopupState] = useState(false);
  const [backdropLoading, setBackdropLoading] = useState(false);

  const classes = useStyles();
  const [queryString] = useState(location);

  useEffect(() => {
    if (idState.length > 0) {
      setIdResetBtnState(true);
    } else {
      setIdResetBtnState(false);
    }
    if (idState.length > 0 && passwordState.length > 0) {
      setLoginButtonState(true);
    } else {
      setLoginButtonState(false);
    }
  }, [idState, passwordState]);

  // 브라우저 언어 감지 useEffect 추가
  useEffect(() => {
    // i18n.js에서 초기화 시 이미 브라우저 언어를 감지하므로 추가 처리 불필요
    console.log('현재 언어:', i18n.language);
  }, [i18n.language]);

  const loginButtonClick = async () => {
    setBackdropLoading(true);
    try {
      const response = await navilinkUserSignIn(
        idState,
        passwordState,
        queryString["search"]
      );
      if (
        response !== undefined &&
        response !== null &&
        response.code === 200
      ) {
        console.log(response.data.location);
        window.location.href = response.data.location;
      } else if (
        response !== undefined &&
        response !== null &&
        response.code !== 200
      ) {
        setPopupState(true);
        console.log(response);
      }
    } catch (e) {
      console.log(e);
    }
    setBackdropLoading(false);
  };

  const reactPopup = () => {
    return (
      <Popup onClose={() => setPopupState(false)} open={popupState}>
        <div
          onClick={() => setPopupState(false)}
          className={NavilinkSignInCss.PopupScreen}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            className={NavilinkSignInCss.Popup}
          >
            <div className={NavilinkSignInCss.PopupTopArea}>
              <strong className={NavilinkSignInCss.PopupTopText}>
                로그인에 실패했습니다.
              </strong>
            </div>
            <div className={NavilinkSignInCss.PopupContentArea}>
              <p className={NavilinkSignInCss.PopupContentTitleText}>
                계정이 없거나 정보를 잘못 입력했습니다.
              </p>
            </div>
            <div className={NavilinkSignInCss.PopupConfirmBtnArea}>
              <button
                onClick={() => setPopupState(false)}
                className={NavilinkSignInCss.PopupConfirmBtn}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      </Popup>
    );
  };
  return (
    <div className={NavilinkSignInCss.BackgroundScreen}>
      <Backdrop className={classes.backdrop} open={backdropLoading}>
        <CircularProgress color={"primary"} />
      </Backdrop>
      {reactPopup()}
      <div className={NavilinkSignInCss.MainScreen}>
        <div className={NavilinkSignInCss.TopArea} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <img
            className={NavilinkSignInCss.MainLogo}
            alt={"navilinkMainLogo"}
            src={MainLogoImage}
            style={{
              maxWidth: "70vw",
              height: "auto",
              display: "block",
              margin: "20px auto",
            }}
          />
          {/* 언어 변경 버튼 제거: 브라우저 언어 설정에 따라 자동 적용 */}

          {/* <strong className={NavilinkSignInCss.TopAreaStrong}>
            나비엔 나비링크
          </strong> */}
        </div>
        <div className={NavilinkSignInCss.ContentArea}>
          <div className={NavilinkSignInCss.InputArea}>
            <label className={NavilinkSignInCss.IdLabel}>{t('accountId')}</label>
            <div className={NavilinkSignInCss.InputDiv}>
              <div className={NavilinkSignInCss.InputLeftArea}>
                <img
                  className={NavilinkSignInCss.IdIcon}
                  alt={"IdIcon"}
                  src={IdIcon}
                />
                <input
                  type="text"
                  name="username"
                  id="username"
                  value={idState}
                  className={NavilinkSignInCss.Input}
                  placeholder={t('accountIdPlaceholder')}
                  onChange={(event) => setIdState(event.target.value)}
                />
              </div>
              <div className={NavilinkSignInCss.InputRight}>
                {idResetBtnState && (
                  <button
                    type="reset"
                    className={NavilinkSignInCss.IdInputReset}
                    onClick={() => setIdState("")}
                  ></button>
                )}
              </div>
            </div>
          </div>
          <div className={NavilinkSignInCss.InputArea}>
            <label className={NavilinkSignInCss.IdLabel}>{t('userPassword')}</label>
            <div className={NavilinkSignInCss.InputDiv}>
              <div className={NavilinkSignInCss.InputLeftArea}>
                <img
                  className={NavilinkSignInCss.IdIcon}
                  alt={"PwIcon"}
                  src={PwIcon}
                />
                <input
                  type={passwordShowBtnState ? "text" : "password"}
                  name="password"
                  id="password"
                  value={passwordState}
                  className={NavilinkSignInCss.Input}
                  placeholder={t('passwordPlaceholder')}
                  onChange={(event) => setPasswordState(event.target.value)}
                />
              </div>
              <div className={NavilinkSignInCss.InputRight}>
                {passwordShowBtnState ? (
                  <button
                    type="button"
                    className={NavilinkSignInCss.PwInputOpen}
                    onClick={() =>
                      setPasswordShowBtnState(!passwordShowBtnState)
                    }
                  ></button>
                ) : (
                  <button
                    type="button"
                    className={NavilinkSignInCss.PwInputClose}
                    onClick={() =>
                      setPasswordShowBtnState(!passwordShowBtnState)
                    }
                  ></button>
                )}
              </div>
            </div>
          </div>
          <button
            className={NavilinkSignInCss.LoginBtn}
            onClick={loginButtonClick}
            disabled={!loginButtonState}
          >
            {t('signInButton')}
          </button>
        </div>
        <div className="container">
          <p>
            {t('alexaDescription')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavilinkSignIn;
